import {ErrorDtoFactory, UserDto} from "../../dtos";
import {Dispatch} from "redux";
import {Action} from "../actions/storeForAccountActions";
import {ActionType} from "../actionTypes";
import envManager from "../../com/envManager/EnvManager";
import axios from "axios";


export const uploadItemsExcelFileForStore = (
    file: File,
    languageCultureCode: string = 'en-US',
    optionValue: string = "1",
) => {
    let userDtoStr = localStorage.getItem("userDto");
    if(!userDtoStr){
        // if no userData exist
        return async () => {}
    }

    return async (
        dispatch: Dispatch<Action>
    ) => {
        dispatch({
            type: ActionType.UPLOAD_STORE_ITEMS_EXCEL_FILE_START
        });

        try {
            let result: any = await uploadExcelFileRequest(
                file,
                languageCultureCode,
                "UploadItemsExcel",
                optionValue,
            );

            dispatch({
                type: ActionType.UPLOAD_STORE_ITEMS_EXCEL_FILE_SUCCESS,
                payload: {
                    file: file,
                    successInfo: {
                        severityLevel: result.data.severityLevel,
                        userFriendlyMessage: result.data.userFriendlyMessage
                    }
                }
            });
            dispatch({
                type: ActionType.UPLOAD_STORE_ITEMS_EXCEL_FILE_COMPLETE,
            });

        } catch (err) {
            dispatch({
                type: ActionType.UPLOAD_STORE_ITEMS_EXCEL_FILE_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    };
};



export const uploadItemsExcelFileWithImagesForStore = (
    file: File,
    languageCultureCode: string = 'en-US',
    optionValue: string = "1",
) => {
    let userDtoStr = localStorage.getItem("userDto");
    if(!userDtoStr){
        // if no userData exist
        return async () => {}
    }
    return async (
        dispatch: Dispatch<Action>
    ) => {
        dispatch({
            type: ActionType.UPLOAD_STORE_ITEM_IMAGES_EXCEL_FILE_START,
        });

        try {
            let result: any = await uploadExcelFileRequest(
                file,
                languageCultureCode,
                "UploadItemImagesExcel",
                optionValue,
            );

            dispatch({
                type: ActionType.UPLOAD_STORE_ITEM_IMAGES_EXCEL_FILE_SUCCESS,
                payload: {
                    file: null,
                    successInfo: {
                        severityLevel: result.data.severityLevel,
                        userFriendlyMessage: result.data.userFriendlyMessage
                    }
                }
            });

            dispatch({type: ActionType.UPLOAD_STORE_ITEM_IMAGES_EXCEL_FILE_COMPLETE});
        } catch (err) {
            dispatch({
                type: ActionType.UPLOAD_STORE_ITEM_IMAGES_EXCEL_FILE_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};

export const uploadDeletionItemsExcelFileForStore = (
    file: File,
    languageCultureCode: string = 'en-US',
) => {
    let userDtoStr = localStorage.getItem("userDto");
    if(!userDtoStr){
        // if no userData exist
        return async () => {}
    }
    return async (
        dispatch: Dispatch<Action>
    ) => {
        dispatch({
            type: ActionType.DELETE_STORE_ITEMS_EXCEL_FILE_START,
        });

        try {
            let result: any = await uploadExcelFileRequest(
                file,
                languageCultureCode,
                "UploadItemDeletionExcel"
            );

            dispatch({
                type: ActionType.DELETE_STORE_ITEMS_EXCEL_FILE_SUCCESS,
                payload: {
                    file: null,
                    successInfo: {
                        severityLevel: result.data.severityLevel,
                        userFriendlyMessage: result.data.userFriendlyMessage
                    }
                }
            });

            dispatch({type: ActionType.DELETE_STORE_ITEMS_EXCEL_FILE_COMPLETE});
        } catch (err) {
            dispatch({
                type: ActionType.DELETE_STORE_ITEMS_EXCEL_FILE_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};


export const getEmptyFileForStore = (lang: string = 'en-US') => {
    let userDtoStr = localStorage.getItem("userDto");
    if(!userDtoStr){
        // if no userData exist
        return async () => {}
    }
    return async (
        dispatch: Dispatch<Action>
    ) => {
        dispatch({
            type: ActionType.DOWNLOAD_STORE_EMPTY_EXCEL_FILE_START,
        });

        try {
            let result: any = await getStoreExcelTemplate(lang);
            dispatch({type: ActionType.DOWNLOAD_STORE_EMPTY_EXCEL_FILE_SUCCESS});
            const url = window.URL.createObjectURL(new Blob([result.data])); // you can mention a type if you wish
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Template_Lang_${lang === 'he-IL' ? 'Hebrew' : 'English'}_Store_Data.xlsx`); //this is the name with which the file will be downloaded
            link.click();
            // no need to append link as child to body.
            setTimeout(() => window.URL.revokeObjectURL(url), 0);

            dispatch({type: ActionType.DOWNLOAD_STORE_EMPTY_EXCEL_FILE_COMPLETE});
        } catch (err) {
            dispatch({
                type: ActionType.DOWNLOAD_STORE_EMPTY_EXCEL_FILE_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};

const getStoreExcelTemplate = (lang: string) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);
            let url = `${envManager.flyerEditorServerAddress}/api/flyerUpload/GetItemsExcelEmpty?uiContentLanguageCultureCode=${lang}`;
            let result: any = await axios.get(url, {
                responseType: 'blob',
                headers: {
                    // "Content-Type": "multipart/form-data",
                    contentType: 'application/json; charset=utf-8',
                    Authorization: "Bearer " + userDto.token,
                },
            });
            resolve(result);
        } catch (error) {
            new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.onload = () => {
                    if (typeof reader?.result === "string") {
                        error.response.data = JSON.parse(reader?.result);
                    }
                    resolve(error);
                };

                reader.onerror = () => {
                    reject(error);
                };

                reader.readAsText(error.response.data);
            })
                .then(err => {
                    // here your response comes
                    reject(err);
                })
        }
    });
};

const uploadExcelFileRequest = (
    file: File,
    contentLanguageCulture: string,
    wmName: string,
    optionValue: string = "",
) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);

            const formData = new FormData();
            formData.append(`ContentLanguageCulture`, contentLanguageCulture);
            formData.append(`File`, file, file.name);
            if(optionValue !== ""){
                formData.append(`DuplicateItemAction`, optionValue);
            }

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + userDto.token,
                },
            };
            let url = `${envManager.flyerEditorServerAddress}/api/flyerUpload/${wmName}`;
            let result: any = await axios.post(url, formData, config);

            resolve(result);
        } catch (e) {
            reject(e);
        }
    });
};

